// extracted by mini-css-extract-plugin
export default {"toggle-wrapper":"semantic-search-toggle_toggle-wrapper__vM6in","checkbox-item":"semantic-search-toggle_checkbox-item__uK220","checkbox":"semantic-search-toggle_checkbox__Fl8P3"};